import { getEnumObject } from '../utilities.js';

export const integrationSources = {
  ABSHER: 'ABSHER',
  ADMIN: 'ADMIN',
  ARNBSARI: 'ARNBSARI',
  CAPITAL: 'CAPITAL',
  CASHIER_APP: 'CASHIER_APP',
  CONSOLE: 'CONSOLE',
  DBAKSARI: 'DBAKSARI',
  FOCAL: 'FOCAL',
  FOODICS_CAPITAL: 'FOODICS_CAPITAL',
  INMASARI: 'INMASARI',
  INTEGRATION: 'integration',
  INTEGRATION_FOODICS_CAPITAL: 'integration/foodics-capital',
  INTEGRATION_IAM_FOODICS_USERS: 'integration/iam/foodics_users',
  INTERSOFT: 'INTERSOFT',
  KIOSK: 'KIOSK',
  LOYALTY_DEMO: 'LOYALTY_DEMO',
  MSEGAT: 'MSEGAT',
  NAFATH: 'NAFATH',
  NCBKSAJE: 'NCBKSAJE',
  NEAR_PAY: 'NEAR_PAY',
  NEAR_PAY_ACCOUNTS_API: 'NEAR_PAY_ACCOUNTS_API',
  PICO: 'PICO',
  RJHISARI: 'RJHISARI',
  RMS: 'RMS',
  SUPPLY: 'SUPPLY',
  SALESFORCE: 'SALESFORCE',
  TANMEYA: 'TANMEYA',
  WATHQ: 'WATHQ',
  WEBHOOKS: 'WEBHOOKS',
  YAKEEN: 'YAKEEN',
  ZATCA: 'ZATCA',
};

export default getEnumObject(integrationSources);
